import { sanitizeFeedbackPrefill } from '../../modules/help-actions/services/help-actions';

export interface FeedbackPayloadInput {
  type: 'bug' | 'idea';
  title: string;
  description: string;
  workspaceId?: string;
  includeDiagnostics: boolean;
  pathname: string;
  appVersion: string;
  userAgent: string;
  errorStack?: string;
}

export function buildFeedbackPayload(input: FeedbackPayloadInput) {
  return {
    type: input.type,
    title: input.title.trim(),
    description: input.description.trim(),
    ...(input.workspaceId ? { workspaceId: input.workspaceId } : {}),
    ...(input.includeDiagnostics
      ? {
          routePath: input.pathname.split(/[?#]/u, 1)[0].slice(0, 2048),
          appVersion: sanitizeFeedbackPrefill(input.appVersion, 64),
          userAgent: sanitizeFeedbackPrefill(input.userAgent, 512),
          errorStack: sanitizeFeedbackPrefill(input.errorStack, 16_000),
        }
      : {}),
  };
}
